/*
{\n" +
                " \t\"messageType\": \"updateTradePlan\",\n" +
                " \t\"tradePlanId\": 123,\n" +
                " \t\"field\": \"pauseExitTactic\",\n" +
                " \t\"value\": {" +
                "\"tacticId\": \"" + candleTrail.getId() + "\"," +
                "\"isPaused\": " + false +
                "}\n" +
                " }
 */
import { sendWebsocketMessage } from '../../../../../../App';

export function pauseExitTactic(tradePlanId, tacticId, isPaused) {
  const msg = {
    messageType: 'updateTradePlan',
    tradePlanId,
    field: 'pauseExitTactic',
    value: {
      tacticId,
      isPaused,
    },
  };
  sendWebsocketMessage(msg);
}
